import React, {Component} from 'react';
import {marker} from "../../../constants/asseturls";
import {InfoWindow, Marker} from "react-google-maps";
import {byPropKey} from "../../utils";
import {ACTION_SET_SELECTED_UNIT} from "../../../reducers/constants";
import {connect} from "react-redux";
import {compose} from "recompose";
import {withRouter} from "react-router-dom";
import {UNIT} from "../../../constants/routes";
import {getUnitElevation, getUnitLatitude, getUnitLongitude, getUnitName} from "../../unit/utils";

/**
 * A Map Marker component for a single unit to be
 * displayed on the dashboard {@code OverviewMap}
 * component.
 */
class UnitMarker extends Component {
    constructor() {
        super();
        this.state = {
            isInfoWindowOpen: null
        };
    }

    /**
     * To be called while the cursor hovers ON the marker
     */
    onHover = () => {
        this.setState(byPropKey('isInfoWindowOpen', true));
    };

    /**
     * To be called when the cursor hovers OUT of the marker
     */
    onHoverExit = () => {
        this.setState(byPropKey('isInfoWindowOpen', null));
    };

    /**
     * To be called when the marker (not the popup) is clicked
     */
    onMarkerClick = () => {
        this.props.onSetSelectedUnit(this.props.unit);
        this.props.history.push(UNIT);
    };

    render() {
        return (
            <Marker
                key={this.props.unit.unitID}
                position={{ lat: getUnitLatitude(this.props.unit), lng: getUnitLongitude(this.props.unit) }}
                options={{icon: marker}}
                onMouseOver={this.onHover}
                onMouseOut={this.onHoverExit}
                onClick={this.onMarkerClick}
            >
                {
                    this.state.isInfoWindowOpen &&
                    <InfoWindow>
                        <div className="infoWindow">
                            <h6>{getUnitName(this.props.unit)}</h6>
                            <div className="text-small">Lat: {getUnitLatitude(this.props.unit)}</div>
                            <div className="text-small">Long: {getUnitLongitude(this.props.unit)}</div>
                            {
                                getUnitElevation(this.props.unit) &&
                                <div className="text-small">Elevation: {getUnitElevation(this.props.unit)}m</div>
                            }
                        </div>
                    </InfoWindow>
                }
            </Marker>
        );
    }
}

/**
 * Map Redux {@param dispatch} a.k.a. actions to component props
 */
const mapDispatchToProps = (dispatch) => ({
    onSetSelectedUnit: (selectedUnit) => dispatch({type: ACTION_SET_SELECTED_UNIT, selectedUnit})
});

export default compose(
    withRouter,
    connect(null, mapDispatchToProps)
)(UnitMarker);



// WEBPACK FOOTER //
// ./src/components/dashboard/overviewmap/UnitMarker.jsx